<template>
  <div>
    <Loader v-if="isLoading" class="py-3" />

    <div
      v-if="isSuccess && isValidArray(ridesCategories)"
      class="categories categories--custom"
    >
      <label>{{ label }}</label>
      <v-radio-group
        v-model="value"
        class="pt-1 mt-0 mb-2"
        :v-validate="vValidate"
        :data-vv-name="dataVvName"
        :error-messages="errorMessages"
        required
        @change="handleUpdate"
      >
        <v-radio
          v-for="rideCategory in ridesCategories"
          :key="rideCategory.value"
          :value="rideCategory.value"
        >
          <template slot="label">
            <div class="category">
              <div class="category__label">
                <img
                  :src="rideCategory.img"
                  :alt="rideCategory.text"
                >
                <span>{{ rideCategory.text }}</span>
              </div>

              <div class="category__details">
                <div class="category__details__column">
                  <span class="category__details__label">
                    {{ $t(`${namespace}.from`) }}
                  </span>
                  <span class="category__details__text">
                    {{ rideCategory.price | currencyBRL }}
                  </span>
                </div>

                <div class="category__details__column">
                  <span class="category__details__label">
                    {{ $t(`${namespace}.distance`) }}
                  </span>
                  <span class="category__details__text">
                    {{ rideCategory.waitingTime }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { objectToArray, isObject, isArray, getRideCategoryByAttr } from 'utils/functions'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
import Loader from 'components/newWebCall/drawer/Loader'

export default {
  name: 'RidesCategories',
  components: {
    Loader
  },
  props: {
    modelValue: {
      type: String
    },
    label: {
      type: String
    },
    dataVvName: {
      type: String
    },
    vValidate: {
      type: undefined
    },
    errorMessages: {
      type: [Object, Array]
    },
    employeeId: {
      type: [Number, String]
    },
    fromCoordinates: {
      type: Object
    },
    toCoordinates: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      webcallMoveMarkersToggle: ({ webcallMoveMarkers }) => webcallMoveMarkers.toggle
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },

    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.ridesCategories',
      currentStatus: null,
      selectedCategory: null,
      ridesCategories: [],
      rideCategoryEstimateArray: []
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    renderRidesCategories () {
      /* todo: ridesCategoriesList */
      this.ridesCategories = objectToArray(this.$store.state.commonConfig.categories)
        .map(category => {
          const priceTarget = this.rideCategoryEstimateArray.find(cat => cat.estimate.categoryId === category.value)
          const price = priceTarget && priceTarget.estimate && priceTarget.estimate.upperFare
            ? Number(priceTarget.estimate.upperFare)
            : 0

          return {
            ...category,
            price
          }
        })
        .filter(category => category.price)
    },

    handleUpdate (value) {
      this.$emit('update:modelValue', value)
    },

    isValidRequestParams () {
      return this.employeeId &&
        this.isValidObject(this.fromCoordinates) &&
        this.isValidObject(this.toCoordinates)
    },

    async getRideCategoryEstimate () {
      if (!this.isValidRequestParams() || this.isLoading) return

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { data: res } = await this.$apiService.getWebCallCategory(
          this.employeeId,
          { fromLat: this.fromCoordinates.latitude },
          { fromLng: this.fromCoordinates.longitude },
          { toLat: this.toCoordinates.latitude },
          { toLng: this.toCoordinates.longitude }
        )

        this.setCategoryPrice(res.data)
        this.renderRidesCategories()
        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        console.log('ERROR:', error)
        this.currentStatus = STATUS_FAILED
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.rideEstimateErrorMessage`)
        })
        return error
      }
    },

    setCategoryPrice (data) {
      this.rideCategoryEstimateArray = data
    },

    getRideCategoryBizType (value = '') {
      return getRideCategoryByAttr(this, { key: 'value', value: value }).bizType
    }
  },
  mounted () {
    this.getRideCategoryEstimate()
  },
  watch: {
    employeeId () {
      this.getRideCategoryEstimate()
    },
    fromCoordinates: {
      deep: true,
      handler () {
        this.getRideCategoryEstimate()
      }
    },
    toCoordinates: {
      deep: true,
      handler () {
        this.getRideCategoryEstimate()
      }
    },
    webcallMoveMarkersToggle () {
      this.getRideCategoryEstimate()
    },
    value (val) {
      // webcall品类选择模块操作
      Omega.trackBusiness(
        OmegaEventIds.tech_b2bv3_webcall,
        {
          business: OmegaBusiness.webcall,
          type: 'category',
          status: OmegaStatus.op
        }
      )
      const event = ['delivery'].includes(this.getRideCategoryBizType(val)) ? 'openDelivery99Dialog' : 'resetDelivery99Values'
      if (event === 'openDelivery99Dialog') {
        // webcall品类选择模块-选中闪送操作
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_webcall,
          {
            business: OmegaBusiness.webcall,
            type: 'categoryEntrega',
            status: OmegaStatus.op
          }
        )
      }
      this.$emit(event, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.category {
  display: block;
  width: 200px;
}

.category__label {
  background-color: $gray-3;
  border: 1px solid $gray-3;
  border-radius: 16px;
  color: $gray-7;
  display: inline-block;
  height: 32px;
  margin-top: 8px;
  margin-right: 8px;
  padding-right: 10px;
  position: relative;

  img {
    background-color: #fff;
    border: 1px solid $gray-3;
    border-radius: 50%;
    height: 32px;
    left: -1px;
    position: relative;
    top: -1px;
    width: 32px;
  }

  span {
    margin-left: 8px;
    position: relative;
    top: -12px;
  }
}

.category__details {

  &:before,
  &:after {
    content: '';
    display: block;
    width: 100%;
  }
}

.category__details__column {
  float: left;
  width: 50%;
}

.category__details__label {
  color: $gray-6;
  font-size: 12px;
  display: block;
}
</style>

<style lang="scss">
.categories--custom {

  .v-input--selection-controls__input {
    top: -18px;
  }
}

.v-input--radio-group.error--text {

  .category__details__label {
    color: $error !important;
  }
}
</style>
